module.exports = __webpack_public_path__ + "static/media/SO2.17139887.jpg";